<template>
    <div>
        <div v-if="this.$store.state.locked" class="locked">
            <p v-if="this.$store.state.errorMessage">{{ this.$store.state.errorMessage }}</p>
            <p v-if="!this.$store.state.errorMessage">{{ t("Erreur d'application. Veuillez rafraîchir la page où réessayer dans une heure. Si l'erreur persiste,") }}</p>
            <p v-if="this.$store.state.errorCode !== 406 && this.$store.state.errorCode !== 405 && this.$store.state.errorCode !== 500">{{ t("veuillez nous contacter par téléphone")}}: <a href="tel:00352 54 98 98">+352 54 98 98</a></p>
            <p v-if="this.$store.state.errorCode === 405">{{ t("Veuillez sélectionner une date correspondante")}}</p>
            <button v-if="this.$store.state.errorCode === 406 || !this.$store.state.errorMessage" onclick="window.location.reload();">actualiser la page</button>
            <button v-if="this.$store.state.errorCode === 405 || this.$store.state.errorCode === 500" @click="closeAlert">fermer</button>
        </div>
        <Header></Header>
        <main>
            <form @submit="onSubmit" class="wrap">
                <div v-if="this.$store.state.confirmation === false">
                    <CardVerification></CardVerification>
                    <div v-if="this.$store.state.sivecNumberConfirmation">
                        <PlateVerification></PlateVerification>
                        <VehicleSelection ></VehicleSelection>
                        <DateTimeSelection v-if="this.$store.state.dateSelection"></DateTimeSelection>
                        <MaterialSelection></MaterialSelection>
                        <ContactDetails></ContactDetails>
                        <Conditions></Conditions>
                        <Summary v-if="this.$store.state.summarySection"></Summary>
                    </div>
                </div>
                <Confirmation v-if="this.$store.state.confirmation"></Confirmation>
            </form>
        </main>
    </div>
</template>

<script>
    import Header from './components/Header'
    import CardVerification from './components/CardVerification'
    import VehicleSelection from './components/VehicleSelection'
    import PlateVerification from './components/PlateVerification'
    import DateTimeSelection from './components/DateTimeSelection'
    import MaterialSelection from './components/MaterialSelection'
    import ContactDetails from './components/ContactDetails'
    import Conditions from './components/Conditions'
    import Summary from './components/Summary'
    import Confirmation from './components/Confirmation'

    const axios = require('axios');

    export default {
    name: 'App',
    debug: true,
    metaInfo() {
        return {
            title: `SIVEC - Prise de rendez-vous`,
        }
    },
    components: {
        Header,
        CardVerification,
        VehicleSelection,
        PlateVerification,
        DateTimeSelection,
        MaterialSelection,
        ContactDetails,
        Conditions,
        Summary,
        Confirmation,
    },
    created() {
        this.$translate.setLang(this.$store.state.language);
    },
    mounted() {
      console.log(1)
        if (localStorage.sivecNumber) {
            this.$store.commit('changeData', {
                type: 'sivecNumber',
                value: localStorage.sivecNumber,
            });
        }
    },
    methods: {
        closeAlert() {
            this.$store.commit('changeData', {
                type: 'errorCode',
                value: null
            });
            this.$store.commit('changeData', {
                type: 'locked',
                value: false
            });
            this.$store.commit('addErrorMessage', null);

        },
        onSubmit(ev) {
            ev.preventDefault();
            this.$store.commit('changeData', {
                type: 'isSubmitting',
                value: true,
            })
            const appointment = {
                "card": this.$store.state.sivecNumber,
                "vehicleType": this.$store.state.vehicleTypeId,
                "plateNumber": this.$store.state.plateNumber,
                "appointmentAt": this.$store.state.appointmentAt,
                "isMaximumLimitAccepted": true,
                "wasteTypes": this.$store.state.materialSelection,
                "comment": "",
                "phoneNumber": this.$store.state.phone,
                "email": this.$store.state.email,
                "isNewsletterAccepted": this.$store.state.newsletter,
                "isConditionsAccepted": true,
                "isConfirmed": true
            }
            const v = this;

            // Check for post or patch request
            let method = 'post';
            let url = `${this.$store.state.domain}/api/fr/appointments`;
            if (this.$store.state.isExistingAppointment){
                method = 'put';
                url = `${this.$store.state.domain}/api/fr/appointments/${this.$store.state.appointmentId}/${this.$store.state.confirmationToken}`
            }
            axios.request({
                method: method,
                url: url,
                data: appointment
            }).then(function (response) {
                    localStorage.removeItem('sivecNumber');
                    v.$store.commit('changeData', {
                      type: 'isSubmitting',
                      value: false,
                    });

                    v.$store.commit('changeData', {
                        type: 'confirmation',
                        value: true,
                    });
                    v.$store.commit('changeData', {
                        type: 'confirmationToken',
                        value: response.data.confirmationToken,
                    });

                const w = v;
                    v.$store.state.imageFiles.forEach((file) => {
                      const x = w;
                      axios.post(`${w.$store.state.domain}/api/fr/appointments/${response.data.id}/files?filename=${file.name}`,
                        file
                      )
                        .then(function (response) {
                          console.log(response);
                        })
                        .catch(error => {
                          x.$store.commit('addErrorMessage', 'Une confirmation a été envoyée à vos coordonnées. ' + error.response.data.extraData.message);
                          x.$store.commit('lockApp');

                            this.$store.commit('changeData', {
                                type: 'isSubmitting',
                                value: true,
                            })
                        })
                    })
                })
                .catch(error => {
                    if (error.response?.status === 500) {
                        // Open up error popup
                        this.$store.commit('addErrorMessage', 'Erreur d\'application. Veillez réessayer d\'envoyer la demande');
                        this.$store.commit('lockApp');
                        this.$store.commit('changeData', {
                            type: 'errorCode',
                            value: 500
                        })

                        // Enable submit button
                        this.$store.commit('changeData', {
                            type: 'isSubmitting',
                            value: false,
                        })
                    } else {
                        this.$store.commit('addErrorMessage', error.response?.data?.extraData?.message || 'Error');
                        this.$store.commit('lockApp');
                        this.$store.commit('changeData', {
                            type: 'errorCode',
                            value: 406
                        })
                    }
                })
        }
    },
}
</script>
<style>
    @import "normalise.css";
</style>
<style>
    @import url("https://use.typekit.net/vex4dqt.css");

    html {
        box-sizing: border-box;
        font-size: 100%;
        min-height: 100%;
    }

    *,
    *::before,
    *::after {
        box-sizing: inherit;
    }

    /*********************
    COLORS
    *********************/

    :root {
        --green--light: #D3E8C1;
        --green: #6AB42D;
        --green--dark: #215551;
        --green--black: #232523;
        --grey: #657C7B;
        --grey--light: #EEECEC;
        --orange: #CF4318;

        --small: 7px;
        --medium: 15px;
        --xmedium: 30px;
        --large: 45px;
        --xlarge: 60px;
        --xxlarge: 120px;
    }

    main {
        overflow: hidden;
    }

    body {
        font-family: gill-sans-nova, sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 18px;
        min-height: 100%;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: montserrat,sans-serif;
        font-weight: 800;
        font-style: normal;
    }

    h2 {
        font-size: 38px;
    }

    ul {
        list-style: none;
        padding-left: 0;
        margin: 0;
    }

    a {
        text-decoration: none;
    }

    button,
    [type=button] {
        background-color: transparent;
        border: none;
    }

    button:hover {
        cursor: pointer;
    }

    .wrap {
        padding-right: 15px;
        padding-left: 15px;
        max-width: 1200px;
        margin: 0 auto;
        width: 100%;
    }

    .locked {
        background-color: rgba(255, 255, 255, 0.95);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 10px;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 99999;
    }

    .locked p {
        font-size: 26px;
        line-height: 32px;
        margin: 0 auto;
        max-width: 800px;
        text-align: center;
    }

    .locked a {
        color: var(--green--dark);
    }

    body {
        overflow-y: scroll;
    }

    body::after {
        content: '';
        background-color: var(--green--light);
        position: absolute;
        top: 600px;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: -1;
    }

    @media only screen and (max-width: 500px) {
        body::after {
            top: 400px;
        }
    }

</style>
<style scoped>
    button {
        margin-top: 50px;
        padding: var(--medium);
        background-color: var(--green);
        border-radius: 30px;
        color: white;
        font-family: gill-sans-nova, sans-serif;
        font-weight: 700;
        text-transform: uppercase;
        text-align: center;
    }
</style>
